export default function ObsMask({ isGreenScreen }) {
  if (isGreenScreen === undefined) isGreenScreen = false;
  return (
    <svg
      width="1920"
      height="1080"
      id="ez-a-hatter"
      className="absolute top-0 left-0 z-[-1]"
    >
      <defs>
        <pattern
          id="img1"
          patternUnits="userSpaceOnUse"
          width="1920"
          height="1080"
        >
          <image
            href=""
            x="0"
            y="0"
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid meet"
          />
        </pattern>
      </defs>
      <defs>
        <mask id="cutout-mask" x="0" y="0" width="1920" height="1080">
          <rect x="0" y="0" width="1920" height="1080" fill="white" />
          <rect
            x="25"
            y="40"
            width="1400"
            height="790"
            fill="black"
            rx="20"
            id="screen"
          />
          {isGreenScreen ? (
            <rect
              x="1440"
              y="40"
              width="455"
              height="290"
              fill="black"
              className="transition-opacity duration-500 ease-in-out opacity-0"
              rx="20"
              id="kamera"
            />
          ) : (
            <rect
              x="1440"
              y="40"
              width="455"
              height="290"
              fill="black"
              rx="20"
              id="kamera"
              className="transition-opacity duration-500 ease-in-out opacity-100"
            />
          )}
        </mask>
      </defs>
      <rect
        x="0"
        y="0"
        width="1920"
        height="1080"
        /*fill="url(#img1)"*/ fill="black"
        mask="url(#cutout-mask)"
      />
    </svg>
  );
}
